import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import profile from "../../components/images/profile.jpg";

export default function MediaCard() {
  return (
    <Card sx={{ marginTop: "100px" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <CardMedia
            component="img"
            sx={{
              width: { xs: "100%", sm: "100%" }, // 80% width on extra-small devices, 100% on small and larger
              height: "auto",
              // Center the image on extra-small devices
            }}
            image={profile}
            alt="profile-photo"
          />
        </Grid>
        <Grid item xs={12} sm={9}>
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              About Me
            </Typography>
            <Typography variant="body2" color="text.secondary">
              I hold a Bachelor's degree in Computer Science and have completed
              a full stack apprenticeship from 10x Academy, where I gained
              comprehensive knowledge and hands-on experience in MERN stack
              technologies (MongoDB, Express.js, React.js, Node.js).
              <br />
              <br />
              Following my apprenticeship, I started my professional journey as
              a software developer. In this role, I worked for seven months,
              primarily focusing on frontend development with React.js and
              JavaScript. I also gained experience as a full stack developer,
              where I spent four months working with React.js and three months
              developing Word and Excel plugins using the Word JavaScript API.
              <br />
              <br />
              With a solid foundation in both frontend and full stack
              development, I am passionate about creating efficient and
              user-friendly web applications. I am always eager to learn and
              apply new technologies to solve complex problems.
            </Typography>
          </CardContent>
        </Grid>
      </Grid>
    </Card>
  );
}
